export default __webpack_public_path__ + "static/media/pol.285ea73e.png";